const LK_TimerClock =({color,width,height})=>{
    return(
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"  fill={color} width={width} height={height} viewBox="0 0 116.99 116.99">
            <path class="cls-1" d="M58.49,17.33c22.7,0,41.16,18.47,41.16,41.16s-18.47,41.16-41.16,41.16-41.16-18.47-41.16-41.16S35.8,17.33,58.49,17.33M58.49,13c-25.13,0-45.49,20.37-45.49,45.49s20.37,45.49,45.49,45.49,45.49-20.37,45.49-45.49S83.62,13,58.49,13h0Z"/>
            <path class="cls-1" d="M58.49,4.33c29.86,0,54.16,24.3,54.16,54.16s-24.3,54.16-54.16,54.16S4.33,88.36,4.33,58.49,28.63,4.33,58.49,4.33M58.49,0C26.19,0,0,26.19,0,58.49s26.19,58.49,58.49,58.49,58.49-26.19,58.49-58.49S90.8,0,58.49,0h0Z"/>
            <polygon class="cls-1" points="89.18 77.58 55.6 58.19 55.6 26 61.38 26 61.38 54.86 92.07 72.58 89.18 77.58"/>
        </svg>
    );
};

export default LK_TimerClock;